export enum ErrorType {
  BREAKING,
  MAJOR,
  MINOR,
}
